import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { handleLoadingAndErrorState } from "#/redux/util/reduxUtils.js";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/rkg/subjekt";

export const fetchKmgMid = createAsyncThunk(
  "kmg-subjects/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        page,
        filter,
        sort,
        false,
        false
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);
export const fetchKmgMidByKey = createAsyncThunk(
  "kmg-subjects-by-key/page",
  async ({ key = "subjektKey", page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        page,
        filter,
        sort
      );
      return { key, data: response.data };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchKmgMidById = createAsyncThunk(
  "kmg-subjects/id",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(`${baseUrl}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const createKmgSubject = createAsyncThunk(
  "kmg-subjects/create",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(baseUrl, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const thunks = [createKmgSubject];

const dataSlice = createSlice({
  name: "kmgSubjects",
  initialState: {
    page: {},
    details: {},
    byId: {},
    error: null,
    isLoading: false,
    pageByKey: {},
    isLoadingByKey: {},
    errorByKey: {},
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchKmgMid.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;

        (action.payload?.content ?? []).forEach((item) => {
          state.byId[item.id] = item;
        });
      })
      .addCase(fetchKmgMid.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchKmgMid.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchKmgMidByKey.pending, (state, action) => {
        const { key } = action.meta.arg;
        state.isLoadingByKey[key] = true;
        state.errorByKey[key] = null;
      })
      .addCase(fetchKmgMidByKey.fulfilled, (state, action) => {
        const { key, data } = action.payload;
        state.pageByKey[key] = data || {};
        for (const kmg of data?.content ?? []) {
          state.byId[kmg.id] = kmg;
        }
        state.isLoadingByKey[key] = false;
      })
      .addCase(fetchKmgMidByKey.rejected, (state, action) => {
        const { key } = action.meta.arg;
        state.isLoadingByKey[key] = false;
        state.errorByKey[key] = ""; // action?.payload || action?.error?.message || {}";
      })
      .addCase(fetchKmgMidById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.byId[action.payload.id] = action.payload;
        state.details = action.payload;
      })
      .addCase(fetchKmgMidById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchKmgMidById.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createKmgSubject.fulfilled, (state, action) => {
        state.isLoading = false;
        state.details = action.payload;
      });

    handleLoadingAndErrorState(builder, thunks);
  },
});

export default dataSlice.reducer;
